export const viewTextKeys = [
  '?软删',
  'G+主页',
  'G+主页链接不符合规则',
  'GitHub主页',
  'GitHub主页链接不符合规则',
  'Json模式',
  'Schema 结构',
  'Tab 切换到:',
  'URL 设置',
  'URL后缀',
  'ag:i (下午1:10)',
  'g:i A (1:10 下午)',
  'hs编码',
  'linkedin 主页',
  'linkedin 主页链接不符合规则',
  'queryChange 接收到搜索参数:',
  'reddit主页',
  'reddit主页链接不符合规则',
  'schema 名称',
  '一句话描述当前状态',
  '一般交易出库',
  '一般贸易商品',
  '上传开票凭证',
  '上传付款凭证',
  '上传收款凭证',
  '下单时间',
  '业务收入',
  '业务收入管理',
  '个人主页',
  '个人主页链接不符合规则',
  '个人信息',
  '个人简介',
  '个人设置',
  '个人资料',
  '主营业务成本',
  '主营业务收入',
  '主表ID',
  '主键',
  '交易下单时间',
  '交易下单时间：',
  '交易时间',
  '交易额统计',
  '仓库',
  '仓库名称',
  '仓库管理',
  '仓库类型',
  '仓库系统编号',
  '仓库编码',
  '仓库：',
  '基础配置',
  '付款凭证',
  '付款时间',
  '付款金额',
  '代码生成成功，如果设置了控制了，请通过菜单添加页面访问',
  '作者',
  '佣金',
  '佣金统计',
  '佣金统计明细',
  '佣金：',
  '例如: html, asp, php 等等后缀，但是在动态模式下无效',
  '供货价：',
  '保 存',
  '保存',
  '保存失败',
  '修改密码',
  '确认修改',
  '旧密码',
  '新密码',
  '长度',
  '包含大小写字母',
  '包含数字',
  '包含特殊字符',
  '请再次输入新密码',
  '两次密码一致',
  '两次密码不一致',
  '请输入密码',
  '弱',
  '中',
  '强',
  '值[',
  '元',
  '全局',
  '公开',
  '关区代码',
  '关闭',
  '其他',
  '内容',
  '内容必须填写',
  '内容设定',
  '几何图案',
  '出库单类型：',
  '出生日期',
  '出生日期:',
  '分类',
  '分类别名必须填写',
  '分类名称',
  '分类名称必须填写',
  '分类类型',
  '分销佣金',
  '分页显示评论',
  '列表',
  '创建人',
  '创建人ID',
  '创建成功',
  '创建日期',
  '创建时间',
  '创建时间&更新时间',
  '创建时间：',
  '初始化表单数据失败:',
  '删除',
  '删除仓库',
  '删除后该仓库将无法恢复，确定要删除吗？',
  '删除后该商户将无法恢复，确定要删除吗？',
  '删除后该店铺将无法恢复，确定要删除吗？',
  '删除后该标签将无法恢复，确定要删除吗？',
  '删除后该模块将无法恢复，确定要删除吗？',
  '删除后该菜单将无法恢复，确定要删除吗？',
  '删除商户',
  '删除失败',
  '删除店铺',
  '删除成功',
  '删除标签',
  '删除模块',
  '删除菜单',
  '删除该仓库后将无法恢复，确定要删除吗？',
  '删除该商户后将无法恢复，确定要删除吗？',
  '删除该店铺后将无法恢复，确定要删除吗？',
  '删除该模块后将无法恢复，确定要删除吗？',
  '删除该菜单后将无法恢复，确定要删除吗？',
  '利润明细',
  '利润统计',
  '别名',
  '别名可以自定义作 url 短链接使用，所以分类是可以自定义链接的',
  '别名可以自定义分类名称, 通常只包含字母、数字和"_,-"连字符',
  '到期日',
  '加载选项数据失败:',
  '动态模式',
  '包裹总重量：',
  '区内企业代码',
  '区内企业名称',
  '单据日期',
  '单据状态',
  '原始交易单号',
  '原始运单号',
  '友情链接',
  '发布',
  '发货时间',
  '发货时间：',
  '取消',
  '可见',
  '可见性',
  '可评论',
  '合同失效日期',
  '合同生效日期',
  '名',
  '名称',
  '名称必须填写',
  '否',
  '启用',
  '启用评论倒序显示',
  '启用评论审核',
  '启用评论嵌套',
  '售后订单',
  '售后订单详情',
  '商品ID：',
  '商品SKU编号：',
  '商品产地',
  '商品分类',
  '商品列表',
  '商品名称',
  '商品名称：',
  '商品售量排名',
  '商品图片',
  '商品总成本',
  '商品总金额：',
  '商品数量',
  '商品数量：',
  '商品明细',
  '商品状态',
  '商品类型',
  '商品类目',
  '商品详情',
  '商品货号',
  '商品配置',
  '商户名称',
  '商户名称：',
  '商户管理',
  '商户类型',
  '商户系统编号',
  '商户编码',
  '图表数据',
  '图表数据：',
  '地区名',
  '地区状态',
  '地区类目',
  '地区编码',
  '地址',
  '地址管理',
  '增值税率',
  '处理后的查询参数:',
  '处理后的部门数据:',
  '备案号',
  '备案序号',
  '备注',
  '复古',
  '复购用户数',
  '外部货号',
  '头像代理服务器',
  '女',
  '姓名',
  '字典值名',
  '字典值名必须填写',
  '字典值名称',
  '字典名称',
  '字典名称必须填写',
  '字典描述',
  '字典状态',
  '字典键值',
  '字典键值必须填写',
  '字典键名',
  '字典键名必须填写',
  '字段',
  '字段名称',
  '实付金额',
  '实付金额：',
  '实收金额',
  '审核应付账款',
  '审核应收账款',
  '审核操作失败，请检查网络或联系技术人员',
  '审核状态',
  '密码',
  '密码查看',
  '导入',
  '导出',
  '开发者工具',
  '封面',
  '小怪物',
  '岗位',
  '岗位搜索参数 jobs_id:',
  '岗位管理',
  '职级管理',
  '职级名称',
  '新增职级',
  '编辑职级',
  '删除职级',
  '请输入职级名称',
  '删除后该职级将无法恢复，确定要删除吗？',
  '获取职级详情失败:',
  '工作台',
  '工作台显示',
  '已付金额',
  '已存在',
  '已完成',
  '已收金额',
  '常规选项',
  '平台原始单号：',
  '平台原始订单号',
  '年-月-日',
  '年月日结构',
  '广告',
  '广昇平台',
  '广昇数据分析可视化大屏',
  '广昇跨境电商系统',
  '库存列表',
  '库存管理',
  '应付单号',
  '应付金额',
  '应付款核销明细',
  '应收单号',
  '应收款项详情',
  '应收款核销明细',
  '应收账款列表',
  '应收金额',
  '店铺',
  '店铺名称',
  '店铺名称：',
  '店铺管理',
  '店铺系统编号',
  '开启',
  '开票凭证',
  '当前 code >>',
  '当前没有符合条件的数据',
  '当评论者的内容与关键字相匹配的时候，则视为垃圾内容，会直接放入回收站，不予显示。每个关键字占一行录入',
  '往来项目',
  '微博主页',
  '微博主页链接不符合规则',
  '快递明细',
  '快递费',
  '快递费：',
  '性别',
  '性别:',
  '成本价',
  '成本单价：',
  '成本费用',
  '所在城市',
  '所属公司',
  '所属模块',
  '所属模块的值 >>>',
  '所属组件',
  '手机号',
  '打开方式',
  '批量删除',
  '批量发布',
  '投流平台管理',
  '平台名称',
  '平台编辑',
  '投流统计',
  '投流费',
  '折扣金额：',
  '报表时间',
  '按钮',
  '排序',
  '排序不能小于1',
  '接口地址',
  '控制列表是否使用分页功能',
  '控制器生成在',
  '推特主页',
  '推特主页链接不符合规则',
  '描述',
  '提交',
  '提交人',
  '提交失败',
  '提交失败:',
  '提交失败，请检查网络或联系技术人员',
  '根据提示信息完善表格内容',
  '提交应付账款',
  '提交应收账款',
  '财务应付款审核',
  '财务应付款详情',
  '财务应收款',
  '财务应收款审核',
  '提交数据:',
  '提交时间',
  '提示',
  '搜索',
  '搜索条件变化:',
  '搜索标识',
  '摘录',
  '操作',
  '操作动态',
  '操作日志',
  '支付公司',
  '支付公司：',
  '支付手续费',
  '支付时间',
  '支付流水号：',
  '收件人姓名',
  '收支项目管理',
  '收款凭证',
  '收款时间',
  '收款金额',
  '收货地址',
  '收货时间',
  '数字',
  '数据中台系统',
  '数据列表',
  '数据列表表格',
  '数据图表',
  '文本',
  '文章',
  '文章内容必须填写',
  '文章数量',
  '文章标题必须填写',
  '料号',
  '新增',
  '新增平台',
  '新增商品',
  '新增仓库',
  '新增商户',
  '新增失败',
  '新增失败:',
  '新增字段',
  '新增店铺',
  '新增成功',
  '新增成功！',
  '新增模块',
  '新增用户数',
  '新窗口',
  '新窗口打开',
  '日志管理',
  '日期与时间',
  '日期格式',
  '时间',
  '时间格式',
  '时间筛选',
  '明细查询参数:',
  '是',
  '是否新标签打开',
  '昵称',
  '昵称名称必须填写',
  '显示',
  '显示/隐藏',
  '更新',
  '更新后的搜索参数:',
  '更新商户',
  '更新模块',
  '更新失败',
  '更新失败,请重新进行更新或联系技术人员',
  '更新失败:',
  '更新成功',
  '更新成功！',
  '更新时间',
  '更新：',
  '最多显示',
  '最新文章',
  '最近登录时间',
  '最近购买时间',
  '月日结构',
  '未付金额',
  '未找到行数据ID',
  '未找到要更新的数据ID',
  '未找到该部门',
  '未收金额',
  '未知',
  '未通过',
  '本年度销售单量',
  '本年度销售金额',
  '本日销售单量',
  '本日销售金额',
  '本月销售单量',
  '本月销售金额',
  '本窗口',
  '本窗口打开',
  '机器人',
  '权限标识',
  '条',
  '条码',
  '查看',
  '查看密码',
  '标签',
  '标签名称必须填写',
  '标题',
  '核销时间',
  '核销明细',
  '核销状态',
  '核销金额',
  '模块关键字',
  '模块名称',
  '模块描述',
  '模块版本',
  '模块状态',
  '模块目录',
  '模块管理',
  '模型生成在',
  '模版名称',
  '毛利',
  '毛利率',
  '毛重',
  '法定计量单位',
  '法定计量数量',
  '注释',
  '浙江省宁波市',
  '海关备案号',
  '海关备案名称',
  '海关料号',
  '海关税金',
  '海关账册号',
  '消费税率',
  '添加失败',
  '添加默认值',
  '清单号：',
  '渠道平台',
  '渲染使用 JSON 模式',
  '激活菜单',
  '父级分类',
  '父级地区',
  '父级菜单',
  '物流公司',
  '物流公司：',
  '状态',
  '状态切换失败',
  '状态切换成功',
  '状态切换错误:',
  '生成代码',
  '生效日期不能早于失效时间',
  '生效日期不能早于生效时间',
  '生效日期与失效时间不能是同一天',
  '用户列表',
  '用户名',
  '用户头像',
  '用户必须注册并登录才可以发表评论',
  '用户总数',
  '用户报表详情',
  '用户昵称',
  '用户昵称:',
  '用户登录日志',
  '用户统计',
  '申报规格型号',
  '男',
  '登录',
  '登录时间',
  '目前推荐的代理服务器',
  '目录',
  '目录下',
  '相关资料',
  '真实姓名',
  '真实姓名:',
  '确定',
  '确定删除',
  '确认',
  '确认删除吗? 删除后数据表将会保留，如需删除相关表，请手动进行删除!',
  '确认批量发布吗',
  '示例页面',
  '社交',
  '禁用',
  '私密',
  '税金',
  '税额',
  '税额：',
  '站点Logo',
  '站点关键字',
  '站点名称',
  '站点名称必须填写',
  '站点描述',
  '站点版权',
  '站点链接',
  '第三方统计代码',
  '第二计量单位',
  '第二计量数量',
  '简洁模式',
  '管理费用',
  '篇文章',
  '类型',
  '类型:',
  '类型值',
  '类型名称',
  '类目名称',
  '系统订单号',
  '系统订单号：',
  '系统退单号',
  '系统退单号：',
  '系统设置',
  '索引',
  '经营利润',
  '经营利润率',
  '结算商品总价：',
  '统计图表',
  '编辑仓库',
  '编辑商户',
  '编辑商品',
  '编辑店铺',
  '编辑用户',
  '置顶',
  '联系人',
  '联系地址',
  '联系电话',
  '至少上传一张开票凭证',
  '至少上传一张付款凭证',
  '至少上传一张收款凭证',
  '至少填写一个标签',
  '英文昵称',
  '草稿',
  '获取仓库列表失败',
  '获取仓库类型失败',
  '获取商户列表失败',
  '获取商户列表失败，请重新获取数据',
  '获取商户名称失败',
  '获取商户类型列表出错，请重新获取',
  '获取国家列表失败',
  '获取图表数据失败:',
  '获取失败，请检查网络或联系技术人员',
  '获取店铺列表失败',
  '获取平台详情失败',
  '获取所属模块失败',
  '获取所属组件失败',
  '获取数据失败',
  '获取数据成功:',
  '获取明细数据失败',
  '获取明细数据失败:',
  '获取权限标识失败',
  '获取用户信息失败:',
  '获取表单内容失败，请重新获取或联系技术人员',
  '获取详情数据失败，请检查网络或联系技术人员',
  '获取详情数据失败，请重新进入或联系技术人员',
  '获取部门数据成功:',
  '菜单',
  '菜单Icon',
  '菜单名称',
  '菜单管理',
  '菜单管理新增',
  '菜单路由',
  '营业税金及附加',
  '表单校验失败',
  '表单组件',
  '表名',
  '表名必须填写',
  '表注释',
  '角色名',
  '角色名称',
  '角色管理',
  '订单ID',
  '订单号',
  '订单地址：',
  '订单总额',
  '订单成本',
  '订单折扣金额：',
  '订单支付时间：',
  '订单明细',
  '订单状态',
  '订单统计',
  '订单量',
  '订单量统计',
  '订单金额',
  '记住账号',
  '设置 rowData:',
  '评论头像',
  '评论禁用关键字',
  '评论者必须填入名字和电子邮箱地址',
  '评论设置',
  '详情',
  '详细地址',
  '请先填写表字段',
  '请先填写表结构数据',
  '请先选择分类',
  '请勾选商户状态',
  '请勾选审核',
  '请填写主键字段',
  '请填写字段',
  '请填写正确的链接格式',
  '请填写表名',
  '请填写表注释',
  '请填写长度',
  '请填写默认值',
  '请求列表数据:',
  '请求参数:',
  '请求图表数据错误:',
  '请求错误',
  '请输入app_key',
  '请输入app_secret',
  '请输入用户名',
  '请输入仓库名称',
  '请输入仓库类型',
  '请输入付款金额',
  '请输入区内企业代码',
  '请输入区内企业名称',
  '请输入商户名称',
  '请输入商户编码',
  '请输入地址',
  '请输入备注(可选)',
  '请输入密码',
  '请输入店铺名称',
  '请输入平台名称',
  '请输入所在关区代码',
  '请输入接口地址',
  '请输入收款金额',
  '请输入模块关键字',
  '请输入模块名称',
  '请输入模块描述',
  '请输入模块目录',
  '请输入模块路径',
  '请输入海关备案号',
  '请输入海关备案名称',
  '请输入海关账册号',
  '请输入联系人',
  '请输入联系地址',
  '请输入联系电话',
  '请输入菜单名称',
  '请输入路由路径path',
  '请输入邮箱',
  '请输入链接地址',
  '请输入驳回原因',
  '请选择',
  '平台信息错误',
  '请选择仓库',
  '请选择仓库类型',
  '请选择仓库编码',
  '请选择付款时间',
  '请选择作者',
  '请选择删除的文章',
  '请选择删除的标签',
  '请选择商户',
  '请选择商户名称',
  '请选择商户类型',
  '请选择失效日期',
  '请选择店铺',
  '请选择店铺编码',
  '请选择所属商户',
  '请选择所属模块',
  '请选择所属组件',
  '请选择收款时间',
  '请选择日期',
  '请选择是否新标签打开状态',
  '请选择是否缓存',
  '请选择显示/隐藏状态',
  '请选择未发布的文章',
  '请选择权限标识',
  '请选择父级菜单',
  '请选择状态',
  '请选择生效日期',
  '请选择菜单图标',
  '财务应付款',
  '账单详情',
  '账号',
  '账户列表',
  '购买用户数',
  '购买金额',
  '购买频次',
  '费用名称',
  '费用类型',
  '跨境商品',
  '路由path',
  '轮播图',
  '软删除',
  '输入查看密码',
  '输入标签',
  '运单号',
  '运单号：',
  '返回',
  '无法找到来时页面，请手动跳回原页面',
  '退单信息',
  '退单号',
  '退单量',
  '退货原因',
  '退货数量：',
  '退货申请时间',
  '退货申请时间：',
  '选择',
  '选择 Logo',
  '选择作者',
  '选择分类',
  '选择可见性',
  '选择头像',
  '选择字段类型',
  '选择封面',
  '选择已有表',
  '选择类型',
  '选择表引擎',
  '选择表索引',
  '通过',
  '邮箱',
  '部门',
  '部门${id}',
  '部门状态切换失败',
  '部门状态切换错误:',
  '部门管理',
  '部门负责人',
  '重置',
  '重量',
  '金额',
  '利润率',
  '利润率趋势',
  '针对分类多级URL(/a/b)，只使用最后一级(/b)',
  '链接',
  '链接地址',
  '链接地址格式不正确',
  '链接结构',
  '销售价：',
  '销售单价限制',
  '销售渠道排名',
  '销售订单',
  '销售订单详情',
  '销售费用',
  '销售额',
  '销项税金',
  '长度',
  '附加费：',
  '隐藏',
  '需要删除的 id',
  '静态模式',
  '静态页面',
  '页面',
  '驳回原因',
  '默认值',
  '默认目录',
  '业务收入占比',
  '业务收入总额',
  '主营业务收入修改',
  '主营业务收入新增',
  '主营业务收入详情',
  '公司名称',
  '删除业务收入',
  '删除后将无法恢复，确定要删除吗？',
  '删除后该地区将无法恢复，确定要删除吗？',
  '删除后不可恢复，确认要删除该账单吗？',
  '删除后不可恢复，确认要删除该账户吗？',
  '删除地区',
  '删除账户',
  '删除账单',
  '原始回填数据:',
  '原始用户数据:',
  '地区名称',
  '增长率',
  '成功加载子节点，node:',
  '所属年月',
  '操作失败:',
  '操作失败',
  '收入总额统计',
  '收入时间',
  '收入类型',
  '收入金额',
  '新增地区',
  '新增用户',
  '无返回信息',
  '未在 opts 中找到节点 id:',
  '未在数据库找到该地区编号',
  '店铺（客户）',
  '当年总毛利',
  '当年总经营利润',
  '税率',
  '发送',
  '发送审核失败，请检查网络或联系技术人员',
  '发送账单审核',
  '出生日期：',
  '头像',
  '头像：',
  '编辑',
  '编辑地区',
  '审核',
  '审核中',
  '获取详情失败:',
  '获取该节点的子节点失败，请重新获取',
  '获取该节点的子节点失败：',
  '获取用户信息失败',
  '账目编号',
  '账单审核',
  '该节点没有 region_grade，跳过请求：',
  '请求失败，请重新编辑或联系技术人员',
  '当前表单项:',
  '性别：',
  '手机号：',
  '抽屉组件 mounted, 部门选项:',
  '提交搜索参数:',
  '更新后的表单数据:',
  '请输入地区名',
  '请输入地区编码',
  '请输入手机号',
  '请输入用户昵称',
  '请输入真实姓名',
  '请输入详细地址',
  '请输入账号',
  '请输入收入金额',
  '请输入税率',
  '请输入税金',
  '请选择公司',
  '请选择公司名称',
  '请选择出生日期',
  '请选择岗位',
  '请选择性别',
  '请选择角色',
  '请选择部门',
  '分类等级',
  '删除分类',
  '删除后该分类将无法恢复，确定要删除吗？',
  '新增分类',
  '上级部门',
  '删除后该部门将无法恢复，确定要删除吗？',
  '删除部门',
  '操作成功',
  '新增部门',
  '编辑部门',
  '请输入部门名称',
  '部门信息错误',
  '部门名称',
  '删除后该岗位将无法恢复，确定要删除吗？',
  '删除岗位',
  '岗位信息错误',
  '岗位名称',
  '岗位编辑',
  '新增岗位',
  '获取岗位详情失败',
  '请输入岗位名称',
  'API响应:',
  '仅本人数据权限',
  '保存授权失败',
  '全选',
  '全部数据权限',
  '删除后该角色将无法恢复，确定要删除吗？',
  '删除角色',
  '原始提交数据:',
  '所属部门',
  '授权失败',
  '授权成功',
  '数据权限',
  '新增角色',
  '暂无权限数据',
  '最终提交数据:',
  '本部门数据权限',
  '权限名称',
  '自定义数据权限',
  '自定义权限必须选择部门',
  '获取权限列表失败',
  '获取角色数据失败',
  '获取角色权限失败:',
  '获取部门数据失败',
  '角色信息错误',
  '角色列表响应:',
  '角色原始数据:',
  '角色归属',
  '角色授权',
  '角色描述',
  '角色标识',
  '角色编辑',
  '请至少选择一个权限',
  '请输入角色名称',
  '请输入角色标识',
  '请输入分类名称',
  '请选择数据权限范围',
  '请选择分类等级',
  '请选择类目等级',
  '部门及以下数据',
  '业务类型',
  '关联原始单号',
  '分配数量',
  '剩余库存',
  '商品库存分配',
  '商品生产日期',
  '商品过期日期',
  '库存类型',
  '总可用数量',
  '总库存',
  '总锁定数量',
  '批次号',
  '报关单号',
  '报检单号',
  '提单号',
  '数量',
  '是否冻结',
  '生产批号',
  '请分配库存',
  '万',
  '不通过',
  '京东',
  '删除后不可恢复，确认要删除该商品吗？',
  '删除后该平台将无法恢复，确定要删除吗？',
  '删除商品',
  '商品推送上架',
  '商户',
  '天猫国际',
  '应收账款账龄分析',
  '快鲸',
  '未到期',
  '淘宝',
  '渠道',
  '渠道1',
  '渠道3',
  '渠道4',
  '逾期1-30天',
  '逾期31-90天',
  '逾期90天以上',
  '长沙广蜃',
  '请选择年月',
  '请选择店铺（客户）',
  '请选择所属年月',
  '请选择收入时间',
  '请选择收入确认日期',
  '请选择收入类型',
  '请选择父级地区',
  '请勾选审核项',
  '旧密码不能为空',
  '请输入旧密码',
  '请输入新密码',
  '新密码不能与旧密码相同',
  '密码强度不足',
  '请再次输入新密码',
  '两次密码不一致',
  '请填写地区名',
  '请填写地区编码',
  '销售总额',
  '商品利润',
  '商品利润排行',
  '序号',
  '待发送',
  '待审核',
  '最后登录IP',
  '最后登录时间',
  '用户信息',
  '用户昵称：',
  '真实姓名：',
  '确认将该数据项发送至审核？',
  '角色',
  '详细地址：',
  '账号：',
  '邮箱：',
  '密码：',
  '🏠 个人主页',
  '📮 邮箱',
  '🤳 个人头像',
  '上月佣金总额',
  '上月投流',
  '上月环比增长',
  '业务收入信息错误',
  '业务收入利润贡献',
  '业务收入名称',
  '业务收入编辑',
  '佣金总额',
  '佣金总额与增值曲线',
  '创建日期不能为空',
  '删除后该业务收入将无法恢复，确定要删除吗？',
  '删除后该项目将无法恢复，确定要删除吗？',
  '删除费用成本',
  '删除项目',
  '剩余金额',
  '剩余金额不能为空',
  '发放时间',
  '已核销',
  '年度总计',
  '年度佣金总额',
  '当月佣金总额',
  '当月利润',
  '当月利润率',
  '当月毛利',
  '当月毛利率',
  '总佣金',
  '新增业务收入',
  '新增成本费用',
  '新增项目',
  '投流平台',
  '投流总额',
  '投流消耗金额与增值曲线',
  '投流消耗额度占比',
  '投流统计修改',
  '投流统计新增',
  '投流统计详情',
  '投流金额',
  '渠道佣金排行',
  '消耗金额',
  '消耗金额不能为空',
  '生产时间',
  '账单月份',
  '账单月份不能为空',
  '账单编号',
  '报表月份',
  '获取业务收入详情失败',
  '获取费用详情失败',
  '获取项目详情失败',
  '请输入账单月份',
  '请输入业务收入名称',
  '请填写支付时间',
  '请填写费用名称',
  '请填写金额',
  '请输入项目名称',
  '获取商户选项失败:',
  '获取店铺选项失败:',
  '刷新当前行失败',
  '凌晨好',
  '早上好',
  '下午好',
  '晚上好',
  '身体是革命的本钱，该休息啦',
  '一日之计在于晨!',
  '放弃很简单，坚持很酷!',
  '一天工作辛苦了，可以休息下啦~',
  '暂无部门',
  '暂无岗位',
  '个人中心',
  '退出登录',
  '退出成功',
  '退出失败',
  '刷新当前页',
  '全屏',
  '退出全屏',
  '语言切换',
  '中文',
  '英文',
  '确定要退出登录吗？',
  '已切换为中文',
  '已切换为英文',
  '全屏切换失败',
  '固定标签',
  '关闭当前',
  '关闭其他',
  '关闭所有',
  '广昇数据中台',
  '快捷导航',
  '员工动态',
  '登录日志',
  '销售管理',
  '财务管理',
  '系统管理',
  '商品管理',
  '账户管理',
  'BI视图',
  '技术部',
  '人力资源部',
  '财务部',
  '市场部',
  '采购部',
  '仓储部',
  '2小时前',
  '3小时前',
  '在系统管理中配置了新的权限角色',
  '在账户列表中更新了账户信息',
  '在应付账单中提交了一条核销账单',
  '在核销明细中驳回了一条记录',
  '在商品管理中创建了一个新商品',
  '在角色管理中分配了10个角色',
  '在商户管理中新增了一个商户',
  '在库存管理中完成了一次库存分配',
  '修改',
  '更新成本费用',
  '请选择店铺名称',
  '请选择费用类型',
  '请选择投流平台',
  '请选择渠道',
  '请选择生产时间',
  '未核销',
  '预充金额',
  '预充金额不能为空',
  '项目信息错误',
  '项目名称',
  '项目编辑',
  '确认删除该项费用成本？',
  '发送审核',
  '收支项目',
  '是否发送审核',
  '添加核销',
  '请选择单据日期',
  '账期分布',
  '账龄分布',
  '单位',
  '应付账款账龄分析',
  '应收账款总量',
  '当年税金',
  '当月税金',
  '税金余额',
  '单据编号',
  '关区',
  '缴纳税金',
  '税金类型',
  '缴纳公司',
  '缴纳日期',
  '开始时间',
  '结束时间',
  '明细',
  '删除海关税金',
  '税金名称',
  '请选择税金名称',
  '请选择关区',
  '请选择缴纳公司',
  '开始日期',
  '结束日期',
  '请输入单据编号',
  '请输入缴纳税金',
  '请选择缴纳日期',
  '请选择开始日期',
  '请选择结束日期',
  '海关税金新增',
  '海关税金修改',
  '海关税金详情',
  '订单税金不允许修改或新增',
  '清单号',
  '交易下单日期',
  '保证金',
  '订单税金',
  '请选择交易时间',
  '超期金额',
  '发票代码',
  '发票号码',
  '发票类型',
  '上传失败',
  '上传失败:',
  '上传成功',
  '导入销项税金',
  '平台原始单号',
  '开票公司',
  '开票日期',
  '件',
  '文件大小不超过100MB',
  '文件已准备就绪，点击确定开始导入',
  '文件路径:',
  '渠道销售统计',
  '标准税目编码',
  '获取订单详情失败',
  '订单详情信息',
  '请先上传文件',
  '请先下载模板文件，按照模板格式填写数据后再上传',
  '请确保文件格式与模板一致',
  '货物/劳务名称',
  '销项税金详情',
  '下载导入模板',
  '下载模板',
  '上传文件',
  '含税金额',
  '价税合计',
  '不含税金额',
  '原票号码',
  '商品销量占比',
  '删除销项税金',
  '支持 .xlsx, .xls 格式的Excel文件',
  '，每页显示',
  '订单详情',
  '请选择支付时间',
  '收入',
  '一般贸易',
  '价格类型',
  '商品信息',
  '备注(可选填)',
  '关税',
  '跨境贸易',
  '跨境购信息',
  '免费',
  '付费',
  '报关信息',
  '至少上传一张图片',
  '获取申报单位失败',
  '获取计量单位列表失败',
  '请输入SKU',
  '请输入关税',
  '请输入商品名称',
  '请输入商品类型',
  '请输入成本价',
  '请输入重量',
  '请输入货号',
  '请选择商品产地',
  '请输入跨境消费税率',
  '请选择申报单位',
  'BI驾驶舱',
  '删除投流平台',
  '请输入外部货号',
  '请输入料号',
  '请输入备案序号',
  '请输入申报规格型号',
  '请输入hs编码',
  '请输入销售单价限制',
  '请输入条码',
  '货号',
  '请输入增值税率',
  '请输入法定计量数量',
  '请选择法定计量单位',
  '请输入第二计量数量',
  '请选择第二计量单位'
] as const

export function buildZhViewsText(): Record<string, string> {
  return Object.fromEntries(viewTextKeys.map((key) => [key, key]))
}

const exactEnViewsText: Record<string, string> = {
  '?软删': '? Soft Delete',
  'G+主页': 'G+ Profile',
  'G+主页链接不符合规则': 'G+ profile link is invalid',
  'GitHub主页': 'GitHub Profile',
  'GitHub主页链接不符合规则': 'GitHub profile link is invalid',
  'Json模式': 'JSON Mode',
  'Schema 结构': 'Schema Structure',
  'Tab 切换到:': 'Switched tab to:',
  'URL 设置': 'URL Settings',
  'URL后缀': 'URL Suffix',
  'ag:i (下午1:10)': 'ag:i (1:10 PM)',
  'g:i A (1:10 下午)': 'g:i A (1:10 PM)',
  'hs编码': 'HS Code',
  'linkedin 主页': 'LinkedIn Profile',
  'linkedin 主页链接不符合规则': 'LinkedIn profile link is invalid',
  'queryChange 接收到搜索参数:': 'queryChange received search params:',
  'reddit主页': 'Reddit Profile',
  'reddit主页链接不符合规则': 'Reddit profile link is invalid',
  'schema 名称': 'Schema Name',
  '一句话描述当前状态': 'Describe the current status in one sentence',
  '一般交易出库': 'Standard Outbound',
  '一般贸易商品': 'General Trade Goods',
  '上传开票凭证': 'Upload Invoice Voucher',
  '上传付款凭证': 'Upload Payment Voucher',
  '上传收款凭证': 'Upload Receipt Voucher',
  '下单时间': 'Order Time',
  '业务收入': 'Business Revenue',
  '业务收入管理': 'Business Revenue Management',
  '个人主页': 'Personal Homepage',
  '个人主页链接不符合规则': 'Personal homepage link is invalid',
  '个人信息': 'Personal Information',
  '个人简介': 'Profile Bio',
  '个人设置': 'Personal Settings',
  '个人资料': 'Personal Profile',
  '主营业务成本': 'Main Business Cost',
  '主营业务收入': 'Main Business Revenue',
  '主表ID': 'Main Table ID',
  '主键': 'Primary Key',
  '交易下单时间': 'Order Placement Time',
  '交易下单时间：': 'Order Placement Time:',
  '交易时间': 'Transaction Time',
  '交易额统计': 'Transaction Amount Statistics',
  '仓库': 'Warehouse',
  '仓库名称': 'Warehouse Name',
  '仓库管理': 'Warehouse Management',
  '仓库类型': 'Warehouse Type',
  '仓库系统编号': 'Warehouse System Code',
  '仓库编码': 'Warehouse Code',
  '仓库：': 'Warehouse:',
  '基础配置': 'Basic Configuration',
  '付款凭证': 'Payment Voucher',
  '付款时间': 'Payment Time',
  '付款金额': 'Payment Amount',
  '代码生成成功，如果设置了控制了，请通过菜单添加页面访问':
    'Code generated successfully. If a controller was configured, please add menu access for the page.',
  '作者': 'Author',
  '佣金': 'Commission',
  '佣金统计': 'Commission Statistics',
  '佣金统计明细': 'Commission Statistics Details',
  '佣金：': 'Commission:',
  '例如: html, asp, php 等等后缀，但是在动态模式下无效':
    'Examples: html, asp, php and other suffixes, but they are invalid in dynamic mode',
  '供货价：': 'Supply Price:',
  '保 存': 'Save',
  '保存': 'Save',
  '保存失败': 'Save Failed',
  '修改密码': 'Change Password',
  '值[': 'Value [',
  '元': 'CNY',
  '全局': 'Global',
  '公开': 'Public',
  '关区代码': 'Customs District Code',
  '关闭': 'Close',
  '其他': 'Other',
  '内容': 'Content',
  '内容必须填写': 'Content is required',
  '内容设定': 'Content Settings',
  '几何图案': 'Geometric Pattern',
  '出库单类型：': 'Outbound Type:',
  '出生日期': 'Birth Date',
  '出生日期:': 'Birth Date:',
  '分类': 'Category',
  '分类别名必须填写': 'Category alias is required',
  '分类名称': 'Category Name',
  '分类名称必须填写': 'Category name is required',
  '分类类型': 'Category Type',
  '分销佣金': 'Distribution Commission',
  '分页显示评论': 'Paginate Comments',
  '列表': 'List',
  '创建人': 'Creator',
  '创建人ID': 'Creator ID',
  '创建成功': 'Created Successfully',
  '创建日期': 'Creation Date',
  '创建时间': 'Created Time',
  '创建时间&更新时间': 'Created Time & Updated Time',
  '创建时间：': 'Created Time:',
  '初始化表单数据失败:': 'Failed to initialize form data:',
  '删除': 'Delete',
  '删除仓库': 'Delete Warehouse',
  '删除后该仓库将无法恢复，确定要删除吗？':
    'This warehouse cannot be recovered after deletion. Are you sure you want to delete it?',
  '删除后该商户将无法恢复，确定要删除吗？':
    'This merchant cannot be recovered after deletion. Are you sure you want to delete it?',
  '删除后该店铺将无法恢复，确定要删除吗？':
    'This store cannot be recovered after deletion. Are you sure you want to delete it?',
  '删除后该标签将无法恢复，确定要删除吗？':
    'This tag cannot be recovered after deletion. Are you sure you want to delete it?',
  '删除后该模块将无法恢复，确定要删除吗？':
    'This module cannot be recovered after deletion. Are you sure you want to delete it?',
  '删除后该菜单将无法恢复，确定要删除吗？':
    'This menu cannot be recovered after deletion. Are you sure you want to delete it?',
  '删除商户': 'Delete Merchant',
  '删除失败': 'Delete Failed',
  '删除店铺': 'Delete Store',
  '删除成功': 'Deleted Successfully',
  '删除标签': 'Delete Tag',
  '删除模块': 'Delete Module',
  '删除菜单': 'Delete Menu',
  '删除该仓库后将无法恢复，确定要删除吗？':
    'The warehouse cannot be recovered after deletion. Are you sure you want to delete it?',
  '删除该商户后将无法恢复，确定要删除吗？':
    'The merchant cannot be recovered after deletion. Are you sure you want to delete it?',
  '删除该店铺后将无法恢复，确定要删除吗？':
    'The store cannot be recovered after deletion. Are you sure you want to delete it?',
  '删除该模块后将无法恢复，确定要删除吗？':
    'The module cannot be recovered after deletion. Are you sure you want to delete it?',
  '删除该菜单后将无法恢复，确定要删除吗？':
    'The menu cannot be recovered after deletion. Are you sure you want to delete it?',
  '利润明细': 'Profit Details',
  '利润统计': 'Profit Statistics',
  '别名': 'Alias',
  '别名可以自定义作 url 短链接使用，所以分类是可以自定义链接的':
    'Aliases can be used as custom short URLs, so category links can be customized.',
  '别名可以自定义分类名称, 通常只包含字母、数字和"_,-"连字符':
    'The alias can customize the category name and usually contains only letters, numbers, and the characters "_,-".',
  '到期日': 'Due Date',
  '加载选项数据失败:': 'Failed to load option data:',
  '动态模式': 'Dynamic Mode',
  '包裹总重量：': 'Total Package Weight:',
  '区内企业代码': 'In-zone Company Code',
  '区内企业名称': 'In-zone Company Name',
  '单据日期': 'Document Date',
  '单据状态': 'Document Status',
  '原始交易单号': 'Original Transaction No.',
  '原始运单号': 'Original Tracking No.',
  '友情链接': 'Friend Links',
  '发布': 'Publish',
  '发货时间': 'Shipment Time',
  '发货时间：': 'Shipment Time:',
  '取消': 'Cancel',
  '可见': 'Visible',
  '可见性': 'Visibility',
  '可评论': 'Commentable',
  '合同失效日期': 'Contract Expiry Date',
  '合同生效日期': 'Contract Effective Date',
  '名': 'Name',
  '名称': 'Name',
  '名称必须填写': 'Name is required',
  '否': 'No',
  '启用': 'Enabled',
  '启用评论倒序显示': 'Enable Reverse Comment Order',
  '启用评论审核': 'Enable Comment Review',
  '启用评论嵌套': 'Enable Nested Comments',
  '售后订单': 'After-sales Order',
  '售后订单详情': 'After-sales Order Details',
  '商品ID：': 'Product ID:',
  '商品SKU编号：': 'Product SKU:',
  '商品产地': 'Product Origin',
  '商品分类': 'Product Category',
  '商品列表': 'Product List',
  '商品名称': 'Product Name',
  '商品名称：': 'Product Name:',
  '商品售量排名': 'Product Sales Ranking',
  '商品图片': 'Product Image',
  '商品总成本': 'Total Product Cost',
  '商品总金额：': 'Total Product Amount:',
  '商品数量': 'Product Quantity',
  '商品数量：': 'Product Quantity:',
  '商品状态': 'Product Status',
  '商品类型': 'Product Type',
  '商品类目': 'Product Category',
  '商品明细': 'Product Details',
  '商品详情': 'Product Details',
  '商品货号': 'Product Item No.',
  '商品配置': 'Product Configuration',
  '商户名称': 'Merchant Name',
  '商户名称：': 'Merchant Name:',
  '商户管理': 'Merchant Management',
  '商户类型': 'Merchant Type',
  '商户系统编号': 'Merchant System Code',
  '商户编码': 'Merchant Code',
  '图表数据': 'Chart Data',
  '图表数据：': 'Chart Data:',
  '地区名': 'Region Name',
  '地区状态': 'Region Status',
  '地区类目': 'Region Category',
  '地区编码': 'Region Code',
  '地址': 'Address',
  '地址管理': 'Address Management',
  '增值税率': 'VAT Rate',
  '处理后的查询参数:': 'Processed query params:',
  '处理后的部门数据:': 'Processed department data:',
  '备案号': 'Record No.',
  '备案序号': 'Record Sequence No.',
  '备注': 'Remark',
  '复古': 'Retro',
  '复购用户数': 'Repeat Purchase Users',
  '外部货号': 'External Item No.',
  '头像代理服务器': 'Avatar Proxy Server',
  '女': 'Female',
  '姓名': 'Name',
  '字典值名': 'Dictionary Value Name',
  '字典值名必须填写': 'Dictionary value name is required',
  '字典值名称': 'Dictionary Value Name',
  '字典名称': 'Dictionary Name',
  '字典名称必须填写': 'Dictionary name is required',
  '字典描述': 'Dictionary Description',
  '字典状态': 'Dictionary Status',
  '字典键值': 'Dictionary Key Value',
  '字典键值必须填写': 'Dictionary key value is required',
  '字典键名': 'Dictionary Key Name',
  '字典键名必须填写': 'Dictionary key name is required',
  '字段': 'Field',
  '字段名称': 'Field Name',
  '实付金额': 'Paid Amount',
  '实付金额：': 'Paid Amount:',
  '实收金额': 'Received Amount',
  '审核应付账款': 'Review Accounts Payable',
  '审核应收账款': 'Review Accounts Receivable',
  '审核操作失败，请检查网络或联系技术人员': 'Review failed. Please check the network or contact technical support.',
  '审核状态': 'Review Status',
  '密码': 'Password',
  '密码查看': 'View Password',
  '导入': 'Import',
  '导出': 'Export',
  '开发者工具': 'Developer Tools',
  '封面': 'Cover',
  '小怪物': 'Little Monster',
  '岗位': 'Position',
  '岗位搜索参数 jobs_id:': 'Position search param jobs_id:',
  '岗位管理': 'Position Management',
  '职级管理': 'Job Grade Management',
  '职级名称': 'Job Grade Name',
  '新增职级': 'Add Job Grade',
  '编辑职级': 'Edit Job Grade',
  '删除职级': 'Delete Job Grade',
  '请输入职级名称': 'Please enter the job grade name',
  '删除后该职级将无法恢复，确定要删除吗？': 'The job grade cannot be recovered after deletion. Are you sure you want to delete it?',
  '获取职级详情失败:': 'Failed to get job grade detail:',
  '工作台': 'Dashboard',
  '工作台显示': 'Dashboard Display',
  '已付金额': 'Paid Amount',
  '已存在': 'Already Exists',
  '已完成': 'Completed',
  '已收金额': 'Received Amount',
  '常规选项': 'General Options',
  '平台原始单号：': 'Original Platform Order No.:',
  '平台原始订单号': 'Original Platform Order No.',
  '年-月-日': 'Year-Month-Day',
  '年月日结构': 'Year-Month-Day Format',
  '广告': 'Advertisement',
  '广昇平台': 'Guangsheng Platform',
  '广昇数据分析可视化大屏': 'Guangsheng Data Analytics Dashboard',
  '广昇跨境电商系统': 'Guangsheng Cross-border E-commerce System',
  '库存列表': 'Inventory List',
  '库存管理': 'Inventory Management',
  '应付单号': 'Payable No.',
  '应付金额': 'Payable Amount',
  '应付款核销明细': 'Accounts Payable Write-off Details',
  '应收单号': 'Receivable No.',
  '应收款项详情': 'Accounts Receivable Details',
  '应收款核销明细': 'Accounts Receivable Write-off Details',
  '应收账款列表': 'Accounts Receivable List',
  '应收金额': 'Receivable Amount',
  '店铺': 'Store',
  '店铺名称': 'Store Name',
  '店铺名称：': 'Store Name:',
  '店铺管理': 'Store Management',
  '店铺系统编号': 'Store System Code',
  '开启': 'Enable',
  '开票凭证': 'Invoice Voucher',
  '当前 code >>': 'Current code >>',
  '当前没有符合条件的数据': 'There is currently no data matching the conditions',
  '当评论者的内容与关键字相匹配的时候，则视为垃圾内容，会直接放入回收站，不予显示。每个关键字占一行录入':
    'If the comment content matches a keyword, it will be treated as spam and moved directly to the recycle bin without being displayed. Enter one keyword per line.',
  '往来项目': 'Transaction Item',
  '微博主页': 'Weibo Profile',
  '微博主页链接不符合规则': 'Weibo profile link is invalid',
  '快递明细': 'Shipping Details',
  '快递费': 'Shipping Fee',
  '快递费：': 'Shipping Fee:',
  '性别': 'Gender',
  '性别:': 'Gender:',
  '成本价': 'Cost Price',
  '成本单价：': 'Unit Cost:',
  '成本费用': 'Cost Expense',
  '所在城市': 'City',
  '所属公司': 'Company',
  '所属模块': 'Owning Module',
  '所属模块的值 >>>': 'Owning module value >>>',
  '所属组件': 'Owning Component',
  '手机号': 'Mobile Number',
  '打开方式': 'Open Mode',
  '批量删除': 'Batch Delete',
  '批量发布': 'Batch Publish',
  '投流平台管理': 'Traffic Platform Management',
  '投流统计': 'Traffic Statistics',
  '投流费': 'Traffic Cost',
  '折扣金额：': 'Discount Amount:',
  '报表时间': 'Report Time',
  '按钮': 'Button',
  '排序': 'Sort',
  '排序不能小于1': 'Sort value cannot be less than 1',
  '接口地址': 'API Address',
  '控制列表是否使用分页功能': 'Control whether the list uses pagination',
  '控制器生成在': 'Controller generated in',
  '推特主页': 'Twitter Profile',
  '推特主页链接不符合规则': 'Twitter profile link is invalid',
  '描述': 'Description',
  '提交': 'Submit',
  '提交人': 'Submitter',
  '提交失败': 'Submit Failed',
  '提交失败:': 'Submit failed:',
  '提交失败，请检查网络或联系技术人员': 'Submit failed. Please check the network or contact technical support.',
  '根据提示信息完善表格内容': 'Complete the form content according to the instructions',
  '提交应付账款': 'Submit Accounts Payable',
  '提交应收账款': 'Submit Accounts Receivable',
  '财务应付款审核': 'Financial Accounts Payable Review',
  '财务应付款详情': 'Financial Accounts Payable Details',
  '财务应收款': 'Financial Accounts Receivable',
  '财务应收款审核': 'Financial Accounts Receivable Review',
  '提交数据:': 'Submitted data:',
  '提交时间': 'Submit Time',
  '提示': 'Prompt',
  '搜索': 'Search',
  '搜索条件变化:': 'Search condition changed:',
  '搜索标识': 'Search Flag',
  '摘录': 'Excerpt',
  '操作': 'Operation',
  '操作动态': 'Operation Activity',
  '操作日志': 'Operation Log',
  '支付公司': 'Paying Company',
  '支付公司：': 'Paying Company:',
  '支付手续费': 'Payment Fee',
  '支付时间': 'Payment Time',
  '支付流水号：': 'Payment Serial No.:',
  '收件人姓名': 'Consignee',
  '收支项目管理': 'Income/Expense Item Management',
  '收款凭证': 'Receipt Voucher',
  '收款时间': 'Receipt Time',
  '收款金额': 'Receipt Amount',
  '收货地址': 'Delivery Address',
  '收货时间': 'Receiving Time',
  '数字': 'Number',
  '数据中台系统': 'Data Center System',
  '数据列表': 'Data List',
  '数据列表表格': 'Data List Table',
  '数据图表': 'Data Charts',
  '文本': 'Text',
  '文章': 'Article',
  '文章内容必须填写': 'Article content is required',
  '文章数量': 'Article Count',
  '文章标题必须填写': 'Article title is required',
  '料号': 'Material No.',
  '新增': 'Add',
  '新增仓库': 'Add Warehouse',
  '新增商户': 'Add Merchant',
  '新增失败': 'Add Failed',
  '新增失败:': 'Add failed:',
  '新增字段': 'Add Field',
  '新增店铺': 'Add Store',
  '新增成功': 'Added Successfully',
  '新增成功！': 'Added Successfully!',
  '新增模块': 'Add Module',
  '新增用户数': 'New User Count',
  '新窗口': 'New Window',
  '新窗口打开': 'Open in New Window',
  '日志管理': 'Log Management',
  '日期与时间': 'Date & Time',
  '日期格式': 'Date Format',
  '时间': 'Time',
  '时间格式': 'Time Format',
  '时间筛选': 'Time Filter',
  '明细查询参数:': 'Detail query params:',
  '是': 'Yes',
  '是否新标签打开': 'Open in New Tab',
  '昵称': 'Nickname',
  '昵称名称必须填写': 'Nickname is required',
  '显示': 'Show',
  '显示/隐藏': 'Show/Hide',
  '更新': 'Update',
  '更新后的搜索参数:': 'Updated search params:',
  '更新商户': 'Update Merchant',
  '更新模块': 'Update Module',
  '更新失败': 'Update Failed',
  '更新失败,请重新进行更新或联系技术人员': 'Update failed. Please try again or contact technical support.',
  '更新失败:': 'Update failed:',
  '更新成功': 'Updated Successfully',
  '更新成功！': 'Updated Successfully!',
  '更新时间': 'Updated Time',
  '更新：': 'Update:',
  '最多显示': 'Show up to',
  '最新文章': 'Latest Articles',
  '最近登录时间': 'Last Login Time',
  '最近购买时间': 'Last Purchase Time',
  '月日结构': 'Month-Day Format',
  '未付金额': 'Unpaid Amount',
  '未找到行数据ID': 'Row data ID not found',
  '未找到要更新的数据ID': 'Data ID to update was not found',
  '未找到该部门': 'Department not found',
  '未收金额': 'Unreceived Amount',
  '未知': 'Unknown',
  '未通过': 'Rejected',
  '本年度销售单量': "This Year's Sales Orders",
  '本年度销售金额': "This Year's Sales Amount",
  '本日销售单量': "Today's Sales Orders",
  '本日销售金额': "Today's Sales Amount",
  '本月销售单量': "This Month's Sales Orders",
  '本月销售金额': "This Month's Sales Amount",
  '本窗口': 'Current Window',
  '本窗口打开': 'Open in Current Window',
  '机器人': 'Robot',
  '权限标识': 'Permission Identifier',
  '条': 'Items',
  '条码': 'Barcode',
  '查看': 'View',
  '查看密码': 'View Password',
  '标签': 'Tag',
  '标签名称必须填写': 'Tag name is required',
  '标题': 'Title',
  '核销时间': 'Write-off Time',
  '核销明细': 'Write-off Details',
  '核销状态': 'Write-off Status',
  '核销金额': 'Write-off Amount',
  '模块关键字': 'Module Keywords',
  '模块名称': 'Module Name',
  '模块描述': 'Module Description',
  '模块版本': 'Module Version',
  '模块状态': 'Module Status',
  '模块目录': 'Module Directory',
  '模块管理': 'Module Management',
  '模型生成在': 'Model generated in',
  '模版名称': 'Template Name',
  '毛利': 'Gross Profit',
  '毛利率': 'Gross Profit Rate',
  '毛重': 'Gross Weight',
  '法定计量单位': 'Legal Unit',
  '法定计量数量': 'Legal Quantity',
  '注释': 'Comment',
  '浙江省宁波市': 'Ningbo, Zhejiang',
  '海关备案号': 'Customs Record No.',
  '海关备案名称': 'Customs Record Name',
  '海关料号': 'Customs Material No.',
  '海关税金': 'Customs Tax',
  '海关账册号': 'Customs Ledger No.',
  '消费税率': 'Consumption Tax Rate',
  '添加失败': 'Add Failed',
  '添加默认值': 'Add Default Value',
  '清单号：': 'Manifest No.:',
  '渠道平台': 'Channel Platform',
  '渲染使用 JSON 模式': 'Render using JSON mode',
  '激活菜单': 'Active Menu',
  '父级分类': 'Parent Category',
  '父级地区': 'Parent Region',
  '父级菜单': 'Parent Menu',
  '物流公司': 'Logistics Company',
  '物流公司：': 'Logistics Company:',
  '状态': 'Status',
  '状态切换失败': 'Status Switch Failed',
  '状态切换成功': 'Status Switched Successfully',
  '状态切换错误:': 'Status switch error:',
  '生成代码': 'Generate Code',
  '生效日期不能早于失效时间': 'Effective date cannot be earlier than expiry time',
  '生效日期不能早于生效时间': 'Effective date cannot be earlier than the start time',
  '生效日期与失效时间不能是同一天': 'Effective date and expiry date cannot be on the same day',
  '用户列表': 'User List',
  '用户名': 'Username',
  '用户头像': 'User Avatar',
  '用户必须注册并登录才可以发表评论': 'Users must register and log in before posting comments',
  '用户总数': 'Total Users',
  '用户报表详情': 'User Report Details',
  '用户昵称': 'User Nickname',
  '用户昵称:': 'User Nickname:',
  '用户登录日志': 'User Login Log',
  '用户统计': 'User Statistics',
  '申报规格型号': 'Declared Specification Model',
  '男': 'Male',
  '登录': 'Login',
  '登录时间': 'Login Time',
  '目前推荐的代理服务器': 'Currently Recommended Proxy Server',
  '目录': 'Directory',
  '目录下': 'Under Directory',
  '相关资料': 'Related Information',
  '真实姓名': 'Real Name',
  '真实姓名:': 'Real Name:',
  '确定': 'Confirm',
  '确定删除': 'Confirm Delete',
  '确认': 'Confirm',
  '确认删除吗? 删除后数据表将会保留，如需删除相关表，请手动进行删除!':
    'Confirm deletion? The data table will be retained after deletion. If related tables need to be removed, please delete them manually.',
  '确认批量发布吗': 'Confirm batch publish?',
  '示例页面': 'Example Page',
  '社交': 'Social',
  '禁用': 'Disabled',
  '私密': 'Private',
  '税金': 'Tax',
  '税额': 'Tax Amount',
  '税额：': 'Tax Amount:',
  '站点Logo': 'Site Logo',
  '站点关键字': 'Site Keywords',
  '站点名称': 'Site Name',
  '站点名称必须填写': 'Site name is required',
  '站点描述': 'Site Description',
  '站点版权': 'Site Copyright',
  '站点链接': 'Site Link',
  '第三方统计代码': 'Third-party Analytics Code',
  '第二计量单位': 'Second Unit',
  '第二计量数量': 'Second Quantity',
  '简洁模式': 'Simple Mode',
  '管理费用': 'Administrative Expense',
  '篇文章': 'Articles',
  '类型': 'Type',
  '类型:': 'Type:',
  '类型值': 'Type Value',
  '类型名称': 'Type Name',
  '类目名称': 'Category Name',
  '系统订单号': 'System Order No.',
  '系统订单号：': 'System Order No.:',
  '系统退单号': 'System Return No.',
  '系统退单号：': 'System Return No.:',
  '系统设置': 'System Settings',
  '索引': 'Index',
  '经营利润': 'Operating Profit',
  '经营利润率': 'Operating Profit Rate',
  '结算商品总价：': 'Settled Product Total:',
  '统计图表': 'Statistics Chart',
  '编辑仓库': 'Edit Warehouse',
  '编辑商户': 'Edit Merchant',
  '编辑商品': 'Edit Product',
  '编辑店铺': 'Edit Store',
  '编辑用户': 'Edit User',
  '置顶': 'Pin to Top',
  '联系人': 'Contact Person',
  '联系地址': 'Contact Address',
  '联系电话': 'Contact Number',
  '至少上传一张开票凭证': 'Please upload at least one invoice voucher',
  '至少上传一张付款凭证': 'Please upload at least one payment voucher',
  '至少上传一张收款凭证': 'Please upload at least one receipt voucher',
  '至少填写一个标签': 'Please enter at least one tag',
  '英文昵称': 'English Nickname',
  '草稿': 'Draft',
  '获取仓库列表失败': 'Failed to get warehouse list',
  '获取仓库类型失败': 'Failed to get warehouse types',
  '获取商户列表失败': 'Failed to get merchant list',
  '获取商户列表失败，请重新获取数据': 'Failed to get merchant list. Please reload the data.',
  '获取商户名称失败': 'Failed to get merchant name',
  '获取商户类型列表出错，请重新获取': 'Failed to get merchant type list. Please try again.',
  '获取国家列表失败': 'Failed to get country list',
  '获取图表数据失败:': 'Failed to get chart data:',
  '获取失败，请检查网络或联系技术人员': 'Failed to fetch data. Please check the network or contact technical support.',
  '获取店铺列表失败': 'Failed to get store list',
  '获取所属模块失败': 'Failed to get owning module',
  '获取所属组件失败': 'Failed to get owning component',
  '获取数据失败': 'Failed to get data',
  '获取数据成功:': 'Data fetched successfully:',
  '获取明细数据失败': 'Failed to get detail data',
  '获取明细数据失败:': 'Failed to get detail data:',
  '获取权限标识失败': 'Failed to get permission identifier',
  '获取用户信息失败:': 'Failed to get user information:',
  '获取表单内容失败，请重新获取或联系技术人员':
    'Failed to get form content. Please try again or contact technical support.',
  '获取详情数据失败，请检查网络或联系技术人员':
    'Failed to get detail data. Please check the network or contact technical support.',
  '获取详情数据失败，请重新进入或联系技术人员':
    'Failed to get detail data. Please re-enter the page or contact technical support.',
  '获取部门数据成功:': 'Department data fetched successfully:',
  '菜单': 'Menu',
  '菜单Icon': 'Menu Icon',
  '菜单名称': 'Menu Name',
  '菜单管理': 'Menu Management',
  '菜单管理新增': 'Add Menu',
  '菜单路由': 'Menu Route',
  '营业税金及附加': 'Business Tax and Surcharges',
  '表单校验失败': 'Form validation failed',
  '表单组件': 'Form Component',
  '表名': 'Table Name',
  '表名必须填写': 'Table name is required',
  '表注释': 'Table Comment',
  '角色名': 'Role Name',
  '角色名称': 'Role Name',
  '角色管理': 'Role Management',
  '订单ID': 'Order ID',
  '订单号': 'Order No.',
  '订单地址：': 'Order Address:',
  '订单总额': 'Order Total',
  '订单成本': 'Order Cost',
  '订单折扣金额：': 'Order Discount Amount:',
  '订单支付时间：': 'Order Payment Time:',
  '订单明细': 'Order Details',
  '订单状态': 'Order Status',
  '订单统计': 'Order Statistics',
  '订单量': 'Order Count',
  '订单量统计': 'Order Volume Statistics',
  '订单金额': 'Order Amount',
  '记住账号': 'Remember Account',
  '设置 rowData:': 'Set rowData:',
  '评论头像': 'Comment Avatar',
  '评论禁用关键字': 'Blocked Comment Keywords',
  '评论者必须填入名字和电子邮箱地址': 'Commenters must provide a name and email address',
  '评论设置': 'Comment Settings',
  '详情': 'Details',
  '详细地址': 'Detailed Address',
  '请先填写表字段': 'Please fill in the table fields first',
  '请先填写表结构数据': 'Please fill in the table structure first',
  '请先选择分类': 'Please select a category first',
  '请勾选商户状态': 'Please select the merchant status',
  '请勾选审核': 'Please select a review option',
  '请填写主键字段': 'Please fill in the primary key field',
  '请填写字段': 'Please fill in the field',
  '请填写正确的链接格式': 'Please enter a valid link format',
  '请填写表名': 'Please enter the table name',
  '请填写表注释': 'Please enter the table comment',
  '请填写长度': 'Please enter the length',
  '请填写默认值': 'Please enter the default value',
  '请求列表数据:': 'Request list data:',
  '请求参数:': 'Request params:',
  '请求图表数据错误:': 'Request chart data error:',
  '请求错误': 'Request Error',
  '请输入app_key': 'Please enter app_key',
  '请输入app_secret': 'Please enter app_secret',
  '请输入仓库名称': 'Please enter the warehouse name',
  '请输入仓库类型': 'Please enter the warehouse type',
  '请输入付款金额': 'Please enter the payment amount',
  '请输入区内企业代码': 'Please enter the in-zone company code',
  '请输入区内企业名称': 'Please enter the in-zone company name',
  '请输入商户名称': 'Please enter the merchant name',
  '请输入商户编码': 'Please enter the merchant code',
  '请输入地址': 'Please enter the address',
  '请输入备注(可选)': 'Please enter remarks (optional)',
  '请输入密码': 'Please enter the password',
  '请输入店铺名称': 'Please enter the store name',
  '请输入所在关区代码': 'Please enter the customs district code',
  '请输入接口地址': 'Please enter the API address',
  '请输入收款金额': 'Please enter the receipt amount',
  '请输入模块关键字': 'Please enter module keywords',
  '请输入模块名称': 'Please enter the module name',
  '请输入模块描述': 'Please enter the module description',
  '请输入模块目录': 'Please enter the module directory',
  '请输入模块路径': 'Please enter the module path',
  '请输入海关备案号': 'Please enter the customs record number',
  '请输入海关备案名称': 'Please enter the customs record name',
  '请输入海关账册号': 'Please enter the customs ledger number',
  '请输入联系人': 'Please enter the contact person',
  '请输入联系地址': 'Please enter the contact address',
  '请输入联系电话': 'Please enter the contact number',
  '请输入菜单名称': 'Please enter the menu name',
  '请输入路由路径path': 'Please enter the route path',
  '请输入邮箱': 'Please enter the email address',
  '请输入链接地址': 'Please enter the link address',
  '请输入驳回原因': 'Please enter the rejection reason',
  '请选择': 'Please Select',
  '请选择仓库': 'Please select a warehouse',
  '请选择仓库类型': 'Please select a warehouse type',
  '请选择仓库编码': 'Please select a warehouse code',
  '请选择付款时间': 'Please select the payment time',
  '请选择作者': 'Please select an author',
  '请选择删除的文章': 'Please select the articles to delete',
  '请选择删除的标签': 'Please select the tags to delete',
  '请选择商户': 'Please select a merchant',
  '请选择商户名称': 'Please select a merchant name',
  '请选择商户类型': 'Please select a merchant type',
  '请选择失效日期': 'Please select the expiry date',
  '请选择店铺': 'Please select a store',
  '请选择店铺编码': 'Please select a store code',
  '请选择所属商户': 'Please select the parent merchant',
  '请选择所属模块': 'Please select the owning module',
  '请选择所属组件': 'Please select the owning component',
  '请选择收款时间': 'Please select the receipt time',
  '请选择日期': 'Please select a date',
  '请选择是否新标签打开状态': 'Please select whether to open in a new tab',
  '请选择是否缓存': 'Please select whether to cache',
  '请选择显示/隐藏状态': 'Please select the show/hide status',
  '请选择未发布的文章': 'Please select unpublished articles',
  '请选择权限标识': 'Please select a permission identifier',
  '请选择父级菜单': 'Please select the parent menu',
  '请选择状态': 'Please select the status',
  '请选择生效日期': 'Please select the effective date',
  '请选择菜单图标': 'Please select a menu icon',
  '财务应付款': 'Financial Accounts Payable',
  '账单详情': 'Bill Details',
  '账号': 'Account',
  '账户列表': 'Account List',
  '购买用户数': 'Purchasing Users',
  '购买金额': 'Purchase Amount',
  '购买频次': 'Purchase Frequency',
  '费用名称': 'Expense Name',
  '费用类型': 'Expense Type',
  '跨境商品': 'Cross-border Goods',
  '路由path': 'Route Path',
  '轮播图': 'Carousel',
  '软删除': 'Soft Delete',
  '输入查看密码': 'Enter viewing password',
  '输入标签': 'Enter tags',
  '运单号': 'Tracking No.',
  '运单号：': 'Tracking No.:',
  '返回': 'Back',
  '无法找到来时页面，请手动跳回原页面': 'Unable to locate the previous page. Please return manually.',
  '退单信息': 'Return Order Information',
  '退单号': 'Return Order No.',
  '退单量': 'Return Quantity',
  '退货原因': 'Return Reason',
  '退货数量：': 'Return Quantity:',
  '退货申请时间': 'Return Request Time',
  '退货申请时间：': 'Return Request Time:',
  '选择': 'Select',
  '选择 Logo': 'Select Logo',
  '选择作者': 'Select Author',
  '选择分类': 'Select Category',
  '选择可见性': 'Select Visibility',
  '选择头像': 'Select Avatar',
  '选择字段类型': 'Select Field Type',
  '选择封面': 'Select Cover',
  '选择已有表': 'Select Existing Table',
  '选择类型': 'Select Type',
  '选择表引擎': 'Select Table Engine',
  '选择表索引': 'Select Table Index',
  '通过': 'Approved',
  '邮箱': 'Email',
  '部门': 'Department',
  '部门${id}': 'Department ${id}',
  '部门状态切换失败': 'Department status switch failed',
  '部门状态切换错误:': 'Department status switch error:',
  '部门管理': 'Department Management',
  '部门负责人': 'Department Head',
  '重置': 'Reset',
  '重量': 'Weight',
  '金额': 'Amount',
  '利润率': 'Profit Rate',
  '利润率趋势': 'Profit Rate Trend',
  '针对分类多级URL(/a/b)，只使用最后一级(/b)': 'For multi-level category URLs (/a/b), only the last level (/b) is used',
  '链接': 'Link',
  '链接地址': 'Link Address',
  '链接地址格式不正确': 'Invalid link address format',
  '链接结构': 'Link Structure',
  '销售价：': 'Sale Price:',
  '销售单价限制': 'Sales Unit Price Limit',
  '销售渠道排名': 'Sales Channel Ranking',
  '销售订单': 'Sales Order',
  '销售订单详情': 'Sales Order Details',
  '销售费用': 'Sales Expense',
  '销售额': 'Sales Amount',
  '销项税金': 'Output VAT',
  '长度': 'Length',
  '附加费：': 'Surcharge:',
  '隐藏': 'Hide',
  '需要删除的 id': 'ID to delete',
  '静态模式': 'Static Mode',
  '静态页面': 'Static Page',
  '页面': 'Page',
  '驳回原因': 'Rejection Reason',
  '默认值': 'Default Value',
  '默认目录': 'Default Directory',
  '业务收入占比': 'Business Revenue Share',
  '业务收入总额': 'Total Business Revenue',
  '主营业务收入修改': 'Edit Main Business Revenue',
  '主营业务收入新增': 'Add Main Business Revenue',
  '主营业务收入详情': 'Main Business Revenue Details',
  '公司名称': 'Company Name',
  '删除业务收入': 'Delete Business Revenue',
  '删除后将无法恢复，确定要删除吗？': 'Once deleted, it cannot be restored. Are you sure you want to delete it?',
  '删除后该地区将无法恢复，确定要删除吗？':
    'Once this region is deleted, it cannot be restored. Are you sure you want to delete it?',
  '删除后不可恢复，确认要删除该账单吗？': 'Deletion cannot be undone. Are you sure you want to delete this bill?',
  '删除后不可恢复，确认要删除该账户吗？': 'Deletion cannot be undone. Are you sure you want to delete this account?',
  '删除地区': 'Delete Region',
  '删除账户': 'Delete Account',
  '删除账单': 'Delete Bill',
  '原始回填数据:': 'Original populated data:',
  '原始用户数据:': 'Original user data:',
  '地区名称': 'Region Name',
  '增长率': 'Growth Rate',
  '成功加载子节点，node:': 'Child nodes loaded successfully, node:',
  '所属年月': 'Applicable Year-Month',
  '操作失败:': 'Operation failed:',
  '操作失败': 'Operation Failed',
  '收入总额统计': 'Revenue Total Statistics',
  '收入时间': 'Revenue Time',
  '收入类型': 'Revenue Type',
  '收入金额': 'Revenue Amount',
  '新增地区': 'Add Region',
  '新增用户': 'Add User',
  '无返回信息': 'No response information',
  '未在 opts 中找到节点 id:': 'Node ID not found in opts:',
  '未在数据库找到该地区编号': 'Region ID was not found in the database',
  '店铺（客户）': 'Store (Customer)',
  '当年总毛利': 'Total Gross Profit This Year',
  '当年总经营利润': 'Total Operating Profit This Year',
  '税率': 'Tax Rate',
  '发送': 'Send',
  '发送审核失败，请检查网络或联系技术人员':
    'Failed to send for review. Please check the network or contact technical support.',
  '发送账单审核': 'Send Bill for Review',
  '出生日期：': 'Birth Date:',
  '头像': 'Avatar',
  '头像：': 'Avatar:',
  '编辑': 'Edit',
  '编辑地区': 'Edit Region',
  '审核': 'Review',
  '审核中': 'Under Review',
  '获取详情失败:': 'Failed to get details:',
  '获取该节点的子节点失败，请重新获取': 'Failed to get the child nodes of this node. Please try again.',
  '获取该节点的子节点失败：': 'Failed to get the child nodes of this node:',
  '获取用户信息失败': 'Failed to get user information',
  '账目编号': 'Account Entry No.',
  '账单审核': 'Bill Review',
  '该节点没有 region_grade，跳过请求：': 'This node has no region_grade. Skipping request:',
  '请求失败，请重新编辑或联系技术人员': 'Request failed. Please edit again or contact technical support.',
  '当前表单项:': 'Current form items:',
  '性别：': 'Gender:',
  '手机号：': 'Mobile:',
  '抽屉组件 mounted, 部门选项:': 'Drawer mounted, department options:',
  '提交搜索参数:': 'Submitted search params:',
  '更新后的表单数据:': 'Updated form data:',
  '请输入地区名': 'Please enter the region name',
  '请输入地区编码': 'Please enter the region code',
  '请输入手机号': 'Please enter mobile number',
  '请输入用户昵称': 'Please enter user nickname',
  '请输入真实姓名': 'Please enter real name',
  '请输入详细地址': 'Please enter the detailed address',
  '请输入账号': 'Please enter the account',
  '请输入收入金额': 'Please enter the revenue amount',
  '请输入税率': 'Please enter the tax rate',
  '请输入税金': 'Please enter the tax amount',
  '请选择公司': 'Please select a company',
  '请选择公司名称': 'Please select a company name',
  '请选择出生日期': 'Please select the birth date',
  '请选择岗位': 'Please select a position',
  '请选择性别': 'Please select the gender',
  '请选择角色': 'Please select a role',
  '请选择部门': 'Please select a department',
  '分类等级': 'Category Level',
  '删除分类': 'Delete Category',
  '删除后该分类将无法恢复，确定要删除吗？':
    'Once this category is deleted, it cannot be restored. Are you sure you want to delete it?',
  '新增分类': 'Add Category',
  '上级部门': 'Parent Department',
  '删除后该部门将无法恢复，确定要删除吗？':
    'Once this department is deleted, it cannot be restored. Are you sure you want to delete it?',
  '删除部门': 'Delete Department',
  '操作成功': 'Operation Succeeded',
  '新增部门': 'Add Department',
  '编辑部门': 'Edit Department',
  '请输入部门名称': 'Please enter the department name',
  '部门信息错误': 'Department information is incorrect',
  '部门名称': 'Department Name',
  '删除后该岗位将无法恢复，确定要删除吗？':
    'Once this position is deleted, it cannot be restored. Are you sure you want to delete it?',
  '删除岗位': 'Delete Position',
  '岗位信息错误': 'Position information is incorrect',
  '岗位名称': 'Position Name',
  '岗位编辑': 'Edit Position',
  '新增岗位': 'Add Position',
  '获取岗位详情失败': 'Failed to get position details',
  '请输入岗位名称': 'Please enter the position name',
  'API响应:': 'API response:',
  '仅本人数据权限': 'Self Only Data Access',
  '保存授权失败': 'Failed to save authorization',
  '全选': 'Select All',
  '全部数据权限': 'All Data Access',
  '删除后该角色将无法恢复，确定要删除吗？':
    'Once this role is deleted, it cannot be restored. Are you sure you want to delete it?',
  '删除角色': 'Delete Role',
  '原始提交数据:': 'Original submitted data:',
  '所属部门': 'Assigned Department',
  '授权失败': 'Authorization Failed',
  '授权成功': 'Authorization Succeeded',
  '数据权限': 'Data Access',
  '新增角色': 'Add Role',
  '暂无权限数据': 'No permission data available',
  '最终提交数据:': 'Final submitted data:',
  '本部门数据权限': 'Current Department Data Access',
  '权限名称': 'Permission Name',
  '自定义数据权限': 'Custom Data Access',
  '自定义权限必须选择部门': 'Custom data access requires selecting departments',
  '获取权限列表失败': 'Failed to get permission list',
  '获取角色数据失败': 'Failed to get role data',
  '获取角色权限失败:': 'Failed to get role permissions:',
  '获取部门数据失败': 'Failed to get department data',
  '角色信息错误': 'Role information is incorrect',
  '角色列表响应:': 'Role list response:',
  '角色原始数据:': 'Raw role data:',
  '角色归属': 'Role Ownership',
  '角色授权': 'Role Authorization',
  '角色描述': 'Role Description',
  '角色标识': 'Role Identifier',
  '角色编辑': 'Edit Role',
  '请至少选择一个权限': 'Please select at least one permission',
  '请输入角色名称': 'Please enter the role name',
  '请输入角色标识': 'Please enter the role identifier',
  '请输入分类名称': 'Please enter the category name',
  '请选择数据权限范围': 'Please select the data access scope',
  '请选择分类等级': 'Please select the category level',
  '请选择类目等级': 'Please select the category hierarchy level',
  '部门及以下数据': 'Department and Sub-department Data',
  '业务类型': 'Business Type',
  '关联原始单号': 'Related Original Doc No.',
  '分配数量': 'Allocated Quantity',
  '剩余库存': 'Remaining Stock',
  '商品库存分配': 'Product Stock Allocation',
  '商品生产日期': 'Product Production Date',
  '商品过期日期': 'Product Expiry Date',
  '库存类型': 'Stock Type',
  '总可用数量': 'Total Available Quantity',
  '总库存': 'Total Stock',
  '总锁定数量': 'Total Locked Quantity',
  '批次号': 'Batch No.',
  '报关单号': 'Customs Declaration No.',
  '报检单号': 'Inspection Declaration No.',
  '提单号': 'Bill of Lading No.',
  '数量': 'Quantity',
  '是否冻结': 'Frozen Status',
  '生产批号': 'Production Batch No.',
  '请分配库存': 'Please allocate stock',
  '万': '10K',
  '不通过': 'Rejected',
  '京东': 'JD',
  '删除后不可恢复，确认要删除该商品吗？': 'Deletion cannot be undone. Are you sure you want to delete this product?',
  '删除后该平台将无法恢复，确定要删除吗？': 'Deletion cannot be undone. Are you sure you want to delete this Platform?',
  '删除商品': 'Delete Product',
  '删除投流平台': 'Delete Platform',
  '商品推送上架': 'Push Product Online',
  '商户': 'Merchant',
  '天猫国际': 'Tmall Global',
  '应收账款账龄分析': 'Accounts Receivable Aging Analysis',
  '快鲸': 'KuaiJing',
  '未到期': 'Not Yet Due',
  '淘宝': 'Taobao',
  '渠道': 'Channel',
  '渠道1': 'Channel 1',
  '渠道3': 'Channel 3',
  '渠道4': 'Channel 4',
  '逾期1-30天': '1-30 Days Overdue',
  '逾期31-90天': '31-90 Days Overdue',
  '逾期90天以上': 'Over 90 Days Overdue',
  '长沙广蜃': 'Changsha Guangshen',
  '请选择年月': 'Please select the year and month',
  '请选择店铺（客户）': 'Please select a store (customer)',
  '平台信息错误': 'Platform information is invalid',
  '请选择所属年月': 'Please select the applicable year and month',
  '请选择收入时间': 'Please select the revenue time',
  '请选择收入确认日期': 'Please select the revenue recognition date',
  '请选择收入类型': 'Please select the revenue type',
  '请选择父级地区': 'Please select the parent region',
  '请勾选审核项': 'Please select a review item',
  '旧密码不能为空': 'Old password cannot be empty',
  '请输入旧密码': 'Please enter the old password',
  '请输入新密码': 'Please enter the new password',
  '新密码不能与旧密码相同': 'The new password cannot be the same as the old password',
  '密码强度不足': 'Password strength is insufficient',
  '请再次输入新密码': 'Please enter the new password again',
  '两次密码不一致': 'The two passwords do not match',
  '请填写地区名': 'Please fill in the region name',
  '请填写地区编码': 'Please fill in the region code',
  '销售总额': 'Total Sales',
  '商品利润': 'Product Profit',
  '商品利润排行': 'Product Profit Ranking',
  '序号': 'No.',
  '待发送': 'Pending Send',
  '待审核': 'Pending Review',
  '最后登录IP': 'Last Login IP',
  '最后登录时间': 'Last Login Time',
  '用户信息': 'User Information',
  '用户昵称：': 'User Nickname:',
  '真实姓名：': 'Real Name:',
  '确认将该数据项发送至审核？': 'Are you sure you want to send this item for review?',
  '角色': 'Role',
  '详细地址：': 'Detailed Address:',
  '账号：': 'Account:',
  '确认修改': 'Confirm Changes',
  '旧密码': 'Old Password',
  '新密码': 'New Password',
  '包含大小写字母': 'Contain lowercase letters',
  '包含数字': 'Contain numbers',
  '包含特殊字符': 'Contain special characters',
  '两次密码一致': 'Same password twice',
  '弱': 'Weak',
  '中': 'Middle',
  '强': 'strong',
  '邮箱：': 'Email:',
  '密码：': 'Password:',
  '🏠 个人主页': '🏠 Personal Homepage',
  '📮 邮箱': '📮 Email',
  '🤳 个人头像': '🤳 Personal Avatar',
  '上月佣金总额': 'Total Commission Last Month',
  '上月投流': 'Last Month Ad Spend',
  '上月环比增长': 'Month-over-Month Growth',
  '业务收入信息错误': 'Business revenue information is invalid',
  '业务收入利润贡献': 'Business Revenue Profit Contribution',
  '业务收入名称': 'Business Revenue Name',
  '业务收入编辑': 'Edit Business Revenue',
  '佣金总额': 'Total Commission',
  '佣金总额与增值曲线': 'Total Commission and Growth Curve',
  '创建日期不能为空': 'Creation date cannot be empty',
  '删除后该业务收入将无法恢复，确定要删除吗？':
    'This business revenue cannot be restored after deletion. Are you sure you want to delete it?',
  '删除后该项目将无法恢复，确定要删除吗？':
    'This item cannot be restored after deletion. Are you sure you want to delete it?',
  '删除费用成本': 'Delete Cost Expense',
  '删除项目': 'Delete Item',
  '剩余金额': 'Remaining Amount',
  '剩余金额不能为空': 'Remaining amount cannot be empty',
  '发放时间': 'Disbursement Time',
  '已核销': 'Written Off',
  '年度总计': 'Annual Total',
  '年度佣金总额': 'Annual Total Commission',
  '当月佣金总额': 'Current Month Commission Total',
  '当月利润': 'Current Month Profit',
  '当月利润率': 'Current Month Profit Rate',
  '当月毛利': 'Current Month Gross Profit',
  '当月毛利率': 'Current Month Gross Profit Rate',
  '总佣金': 'Total Commission',
  '新增业务收入': 'Add Business Revenue',
  '新增成本费用': 'Add Cost Expense',
  '新增平台': 'Add Platform',
  '新增商品': 'Add Product',
  '新增项目': 'Add Item',
  '投流平台': 'Advertising Platform',
  '平台名称': 'Platform Name',
  '平台编辑': 'Edit Platform',
  '投流总额': 'Total Ad Spend',
  '投流消耗金额与增值曲线': 'Ad Spend and Growth Curve',
  '投流消耗额度占比': 'Ad Spend Consumption Ratio',
  '投流统计修改': 'Edit Ad Spend Statistics',
  '投流统计新增': 'Add Ad Spend Statistics',
  '投流统计详情': 'Ad Spend Statistics Details',
  '投流金额': 'Ad Spend',
  '渠道佣金排行': 'Channel Commission Ranking',
  '消耗金额': 'Consumption Amount',
  '消耗金额不能为空': 'Consumption amount cannot be empty',
  '生产时间': 'Generated Time',
  '账单月份': 'Billing Month',
  '账单月份不能为空': 'Billing month cannot be empty',
  '账单编号': 'Bill Number',
  '报表月份': 'Report Month',
  '获取业务收入详情失败': 'Failed to get business revenue details',
  '获取费用详情失败': 'Failed to get expense details',
  '获取平台详情失败': 'Failed to get platform details',
  '获取项目详情失败': 'Failed to get item details',
  '请输入账单月份': 'Please enter billing month',
  '请输入业务收入名称': 'Please enter business revenue name',
  '请输入用户名': 'Please enter the username',
  '请输入平台名称': 'Please enter the platform name',
  '请填写支付时间': 'Please fill in the payment time',
  '请填写费用名称': 'Please fill in the expense name',
  '请填写金额': 'Please fill in the amount',
  '请输入项目名称': 'Please enter item name',
  '获取商户选项失败:': 'Failed to get merchant options:',
  '获取店铺选项失败:': 'Failed to get store options:',
  '刷新当前行失败': 'Failed to refresh current row',
  '凌晨好': 'Good early morning',
  '早上好': 'Good morning',
  '下午好': 'Good afternoon',
  '晚上好': 'Good evening',
  '身体是革命的本钱，该休息啦': 'Health is the foundation of everything. Time to rest.',
  '一日之计在于晨!': 'The whole day depends on a good morning!',
  '放弃很简单，坚持很酷!': 'Giving up is easy, persistence is cool!',
  '一天工作辛苦了，可以休息下啦~': 'You worked hard today. Time to take a break~',
  '暂无部门': 'No Department',
  '暂无岗位': 'No Position',
  '个人中心': 'Profile Center',
  '退出登录': 'Log Out',
  '退出成功': 'Logged out successfully',
  '退出失败': 'Failed to log out',
  '刷新当前页': 'Refresh Current Page',
  '全屏': 'Fullscreen',
  '退出全屏': 'Exit Fullscreen',
  '语言切换': 'Language Switch',
  '中文': 'Chinese',
  '英文': 'English',
  '确定要退出登录吗？': 'Are you sure you want to log out?',
  '已切换为中文': 'Switched to Chinese',
  '已切换为英文': 'Switched to English',
  '全屏切换失败': 'Failed to toggle fullscreen',
  '固定标签': 'Pinned Tab',
  '关闭当前': 'Close Current',
  '关闭其他': 'Close Others',
  '关闭所有': 'Close All',
  '广昇数据中台': 'Coszenmost Data Center',
  '快捷导航': 'Quick Navigation',
  '员工动态': 'Employee Activity',
  '登录日志': 'Login Log',
  '销售管理': 'Sales Management',
  '财务管理': 'Financial Management',
  '系统管理': 'System Management',
  '商品管理': 'Product Management',
  '账户管理': 'Account Management',
  'BI视图': 'BI View',
  '技术部': 'Technology Department',
  '人力资源部': 'Human Resources Department',
  '财务部': 'Finance Department',
  '市场部': 'Marketing Department',
  '采购部': 'Procurement Department',
  '仓储部': 'Warehouse Department',
  '2小时前': '2 hours ago',
  '3小时前': '3 hours ago',
  '在系统管理中配置了新的权限角色': 'Configured a new permission role in System Management',
  '在账户列表中更新了账户信息': 'Updated account information in the account list',
  '在应付账单中提交了一条核销账单': 'Submitted a write-off bill in Accounts Payable',
  '在核销明细中驳回了一条记录': 'Rejected a record in write-off details',
  '在商品管理中创建了一个新商品': 'Created a new product in Product Management',
  '在角色管理中分配了10个角色': 'Assigned 10 roles in Role Management',
  '在商户管理中新增了一个商户': 'Added a new merchant in Merchant Management',
  '在库存管理中完成了一次库存分配': 'Completed a stock allocation in Inventory Management',
  '修改': 'Edit',
  '更新成本费用': 'Edit Cost Expense',
  '请选择店铺名称': 'Please select store name',
  '请选择费用类型': 'Please select an expense type',
  '请选择投流平台': 'Please select advertising platform',
  '请选择渠道': 'Please select channel',
  '请选择生产时间': 'Please select generation time',
  '未核销': 'Not Written Off',
  '预充金额': 'Prepaid Amount',
  '预充金额不能为空': 'Prepaid amount cannot be empty',
  '项目信息错误': 'Item information is invalid',
  '项目名称': 'Item Name',
  '项目编辑': 'Edit Item',
  '确认删除该项费用成本？': 'Are you sure you want to delete this cost expense?',
  '发送审核': 'Send for Review',
  '收支项目': 'Income/Expense Item',
  '是否发送审核': 'Send for Review?',
  '添加核销': 'Add Write-off',
  '请选择单据日期': 'Please select document date',
  '账期分布': 'Billing Period Distribution',
  '账龄分布': 'Aging Distribution',
  '单位': 'Unit',
  '应付账款账龄分析': 'Accounts Payable Aging Analysis',
  '应收账款总量': 'Total Accounts Receivable',
  '当年税金': 'Tax Paid This Year',
  '当月税金': 'Tax Paid This Month',
  '税金余额': 'Tax Balance',
  '单据编号': 'Document Number',
  '关区': 'Customs District',
  '缴纳税金': 'Tax Paid',
  '税金类型': 'Tax Type',
  '缴纳公司': 'Paying Company',
  '缴纳日期': 'Payment Date',
  '开始时间': 'Start Time',
  '结束时间': 'End Time',
  '明细': 'Details',
  '删除海关税金': 'Delete Customs Tax',
  '税金名称': 'Tax Name',
  '请选择税金名称': 'Please select the tax name',
  '请选择关区': 'Please select a customs district',
  '请选择缴纳公司': 'Please select the paying company',
  '开始日期': 'Start Date',
  '结束日期': 'End Date',
  '请输入单据编号': 'Please enter the document number',
  '请输入缴纳税金': 'Please enter the tax paid',
  '请选择缴纳日期': 'Please select the payment date',
  '请选择开始日期': 'Please select the start date',
  '请选择结束日期': 'Please select the end date',
  '海关税金新增': 'Add Customs Tax',
  '海关税金修改': 'Edit Customs Tax',
  '海关税金详情': 'Customs Tax Details',
  '订单税金不允许修改或新增': 'Order tax cannot be edited or added',
  '清单号': 'Manifest Number',
  '交易下单日期': 'Order Date',
  '保证金': 'Security Deposit',
  '订单税金': 'Order Tax',
  '请选择交易时间': 'Please select the transaction time',
  '超期金额': 'Overdue Amount',
  '发票代码': 'Invoice Code',
  '发票号码': 'Invoice Number',
  '发票类型': 'Invoice Type',
  '上传失败': 'Import Failed',
  '上传失败:': 'Import failed:',
  '上传成功': 'Import Successful',
  '导入销项税金': 'Import Output VAT',
  '平台原始单号': 'Original Platform Order No.',
  '开票公司': 'Invoicing Company',
  '开票日期': 'Invoice Date',
  '件': 'pcs',
  '文件大小不超过100MB': 'File size must not exceed 100MB',
  '文件已准备就绪，点击确定开始导入': 'The file is ready. Click Confirm to start importing',
  '文件路径:': 'File path:',
  '渠道销售统计': 'Channel Sales Statistics',
  '标准税目编码': 'Standard Tax Item Code',
  '获取订单详情失败': 'Failed to get order details',
  '订单详情信息': 'Order Details',
  '请先上传文件': 'Please upload a file first',
  '请先下载模板文件，按照模板格式填写数据后再上传':
    'Please download the template first, fill in the data in the required format, and then upload it',
  '请确保文件格式与模板一致': 'Please make sure the file format matches the template',
  '货物/劳务名称': 'Goods/Service Name',
  '销项税金详情': 'Output VAT Details',
  '下载导入模板': 'Download Import Template',
  '下载模板': 'Download Template',
  '上传文件': 'Upload File',
  '含税金额': 'Tax-inclusive Amount',
  '价税合计': 'Total Amount Including Tax',
  '不含税金额': 'Tax-exclusive Amount',
  '原票号码': 'Original Invoice Number',
  '商品销量占比': 'Product Sales Share',
  '删除销项税金': 'Delete Output VAT',
  '支持 .xlsx, .xls 格式的Excel文件': 'Supports Excel files in .xlsx and .xls formats',
  '，每页显示': ', items per page',
  '订单详情': 'Order Details',
  '请选择支付时间': 'Please select the payment time',
  '收入': 'Revenue',
  '一般贸易': 'General Trade',
  '价格类型': 'Price Type',
  '商品信息': 'Product Information',
  '备注(可选填)': 'Remarks (Optional)',
  '关税': 'Tariff',
  '跨境贸易': 'Cross-border Trade',
  '跨境购信息': 'Cross-border Purchase Information',
  '免费': 'Free',
  '付费': 'Paid',
  '报关信息': 'Customs Declaration Information',
  '至少上传一张图片': 'Please upload at least one image',
  '获取申报单位失败': 'Failed to get declaration units',
  '获取计量单位列表失败': 'Failed to get unit list',
  '请输入SKU': 'Please enter SKU',
  '请输入关税': 'Please enter the tariff',
  '请输入商品名称': 'Please enter the product name',
  '请输入商品类型': 'Please enter the product type',
  '请输入成本价': 'Please enter the cost price',
  '请输入重量': 'Please enter the weight',
  '请输入货号': 'Please enter the item number',
  '请选择商品产地': 'Please select the product origin',
  '请输入跨境消费税率': 'Please enter the cross-border consumption tax rate',
  '请选择申报单位': 'Please select the declaration unit',
  'BI驾驶舱': 'BI',
  '请输入外部货号': 'Please enter the external item number',
  '请输入料号': 'Please enter the part number',
  '请输入备案序号': 'Please enter the filing serial number',
  '请输入申报规格型号': 'Please enter the declaration specification/model',
  '请输入hs编码': 'Please enter the HS code',
  '请输入销售单价限制': 'Please enter the sales unit price limit',
  '请输入条码': 'Please enter the barcode',
  '货号': 'Item number',
  '请输入增值税率': 'Please enter the VAT rate',
  '请输入法定计量数量': 'Please enter the statutory quantity',
  '请选择法定计量单位': 'Please select the statutory unit of measurement',
  '请输入第二计量数量': 'Please enter the second quantity',
  '请选择第二计量单位': 'Please select the second unit of measurement'
}

export function buildEnViewsText(): Record<string, string> {
  return Object.fromEntries(viewTextKeys.map((key) => [key, exactEnViewsText[key] ?? key]))
}
